const doc = [({"en":({"js":({"admin":({"users":({"show":({"you_have_been_signed_in_as_the_user":"You have been signed in as the user.", "sign_in_as":"Sign in as"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;